import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "mt-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardWrapper = _resolveComponent("CardWrapper");
    const _component_DialogDeliveryCharge = _resolveComponent("DialogDeliveryCharge");
    const _component_StoreDeliveryPossibleArea = _resolveComponent("StoreDeliveryPossibleArea");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CardWrapper, { "edit-btn-handler": _ctx.handleClickEditBtn }, null, 8 /* PROPS */, ["edit-btn-handler"]),
        _createCommentVNode(" 배달대행료 "),
        (_ctx.storeDetail)
            ? (_openBlock(), _createBlock(_component_DialogDeliveryCharge, { key: 0 }))
            : _createCommentVNode("v-if", true),
        _createCommentVNode(" 배달 가능 동 설정 "),
        (_ctx.storeDetail)
            ? (_openBlock(), _createBlock(_component_StoreDeliveryPossibleArea, {
                key: 1,
                "store-id": _ctx.storeDetail.code,
                "store-name": _ctx.storeDetail.name
            }, null, 8 /* PROPS */, ["store-id", "store-name"]))
            : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                class: "list-btn",
                onClick: _ctx.handleClickReturnBtn
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_icon, { small: "" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createTextVNode(" mdi-chevron-left ")
                        ])),
                        _: 1 /* STABLE */,
                        __: [0]
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.back_to_list')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [
                    _directive_btn_style,
                    void 0,
                    "config",
                    {
                        info: true,
                        outlined: true,
                        "size-l": true,
                        "width-xs": true
                    }
                ]
            ])
        ])
    ]));
}
